export default __webpack_public_path__ + "static/media/no-result.0b2a605a.png";